import { graphql } from '@/gql'

export const UpdateWorksomeIntelligenceConsentMutation = graphql(/* GraphQL */ `
  mutation UpdateWorksomeIntelligenceConsentMutation(
    $input: UpdateWorksomeIntelligenceConsentInput!
  ) {
    updateWorksomeIntelligenceConsent(input: $input)
  }
`)
